import React from "react";

export default function Legend({ pxWidth, pxHeight, labels, colors, opacity }) {
    const oneLegendShift = labels.length === 1 ? pxHeight * 0.08 : 0;
    return (
        <>
            {labels.map((value, index) => (
                <g key={index}>
                    <rect
                        x={(index + 0.55) * (pxWidth * 0.9 / labels.length) - oneLegendShift}
                        y={pxHeight * 0.95}
                        height={pxHeight * 0.02}
                        width={pxHeight * 0.02}
                        fill={colors[index]}
                        opacity={opacity}
                    />
                    <text
                        transform={`translate(${
                            (index + 0.55) * (pxWidth * 0.9 / labels.length) +
                            pxWidth * 0.02 - oneLegendShift
                        }, ${pxHeight * 0.97})`}
                        fontSize={pxHeight * 0.03}
                    >
                        - {value}
                    </text>
                </g>
            ))}
        </>
    );
}
